import { useMemo } from 'react';

import { useEnablePrinterFiltering } from '../../feature-flags/hooks/use-enable-printer-filtering';
import { useCurrentUserId } from '../use-current-user-id';
import { useUserHasAdministrationRole } from '../use-user-role';

import { useWorkstations } from '../use-workstations';
import { usePrinterGroups } from './use-printer-groups';
import { printerGrouper } from './printer-grouper';

export const usePrinters = () => {
  const userId = useCurrentUserId();
  const printerGroups = usePrinterGroups();
  const workstations = useWorkstations();

  const enablePrinterFiltering = useEnablePrinterFiltering();
  const userHasAdministrationRole = useUserHasAdministrationRole();
  const filterOtherUserUnusableWorkstations = !userHasAdministrationRole && enablePrinterFiltering;

  const printers = useMemo(
    () => printerGrouper.groupPrintersByWorkstation(workstations, printerGroups, userId, filterOtherUserUnusableWorkstations),
    [workstations, printerGroups, userId, filterOtherUserUnusableWorkstations],
  );

  return {
    printers,
    hasInstalledShipStationConnect: workstations.length > 0,
  };
};
